/* 🤖 this file was generated by svg-to-ts */
export const kzIconsMenu: {
  name: 'menu';
  data: string;
} = {
  name: 'menu',
  data: `<svg fill="none" viewBox="0 0 16 16"><path d="M5.5 1.25h-3c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25Z" stroke="currentColor" stroke-width="1.5"/><rect x="1.25" y="9.25" width="5.5" height="5.5" rx="1.25" stroke="currentColor" stroke-width="1.5"/><rect x="9.25" y="1.25" width="5.5" height="5.5" rx="1.25" stroke="currentColor" stroke-width="1.5"/><rect x="9.25" y="9.25" width="5.5" height="5.5" rx="1.25" stroke="currentColor" stroke-width="1.5"/></svg>`
};
